import { useState } from "react";
import { Share2, Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { parseSharePath } from "@/lib/share";
import { PublisherBody } from "@/components/SocialPublisher";

const TRIGGERS = {
  icon: "w-9 h-9 rounded-full bg-white/90 hover:bg-white border border-neutral-200 text-ink-800 hover:text-brand flex items-center justify-center shadow-sm transition-colors",
  mini: "w-7 h-7 rounded-full bg-white hover:bg-neutral-50 border border-neutral-200 text-neutral-500 hover:text-brand flex items-center justify-center transition-colors",
  glass: "inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur border border-white/30 text-sm font-semibold text-white transition-colors",
  pill: "inline-flex items-center gap-2 h-10 px-4 rounded-full border border-neutral-200 bg-white text-sm font-semibold text-ink-900 hover:border-brand hover:text-brand transition-colors",
};

export default function ShareButton({ path, kind, keyId, snap, variant = "icon", testid = "share-btn", label = "Share" }) {
  const [open, setOpen] = useState(false);
  const [made, setMade] = useState(null);
  const [busy, setBusy] = useState(false);
  const target = snap ? made : kind ? { kind, key: keyId } : parseSharePath(path);
  if (!snap && !target) return null;
  const start = async () => {
    if (!snap || made) return setOpen(true);
    setBusy(true);
    try {
      const { data } = await api.post("/social/snap", { ...snap, path: window.location.pathname + window.location.search });
      setMade(data);
      setOpen(true);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't prepare this share - please try again.");
    } finally { setBusy(false); }
  };
  const Icon = busy ? Loader2 : Share2;
  return (
    <>
      <button type="button" data-testid={testid} aria-label="Share" className={TRIGGERS[variant]}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); start(); }} disabled={busy}>
        <Icon className={`${variant === "mini" ? "w-3.5 h-3.5" : "w-4 h-4"} ${busy ? "animate-spin" : ""}`} />{(variant === "pill" || variant === "glass") && label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto p-5 sm:p-6" data-testid="share-menu" onClick={(e) => e.stopPropagation()}>
          <DialogHeader className="text-left">
            <DialogTitle className="flex items-center gap-3 font-display">
              <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-brand to-[#FF7A45] text-white flex items-center justify-center"><Sparkles className="w-4 h-4" /></span>
              Smart Social Publisher
            </DialogTitle>
            <DialogDescription>AI-written posts for every platform — copy, download the card and publish in seconds.</DialogDescription>
          </DialogHeader>
          {open && target && <PublisherBody kind={target.kind} keyId={target.key} />}
        </DialogContent>
      </Dialog>
    </>
  );
}
